
export default function ServicesSection() {
  const services = [
    {
      title: '骨盤矯正',
      description: '骨盤の歪みを整え、腰痛や姿勢の改善を図ります。専門的な手技により、身体のバランスを正常に戻します。',
      image: 'https://public.readdy.ai/ai/img_res/ce4aef94c78177bd125e002e5de153eb.jpg',
      icon: 'ri-body-scan-line'
    },
    {
      icon: 'ri-hand-heart-line',
      title: '手技療法',
      description: '熟練した手技により、筋肉の緊張をほぐし、血行を促進します。自然治癒力を高める施術です。',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20therapist%20performing%20expert%20manual%20therapy%20session%20on%20Japanese%20patient%20in%20orthopedic%20clinic%2C%20skilled%20Asian%20therapist%20using%20professional%20massage%20and%20muscle%20manipulation%20techniques%2C%20Japanese%20patient%20receiving%20therapeutic%20treatment%2C%20clean%20medical%20environment%2C%20healing%20hands-on%20approach%20by%20Japanese%20healthcare%20professional%2C%20serene%20treatment%20atmosphere%20in%20Japanese%20clinic&width=400&height=300&seq=service-manual-jp&orientation=landscape'
    },
    {
      icon: 'ri-flashlight-line',
      title: '電気治療',
      description: '最新の電気治療機器を使用し、痛みの緩和と筋肉の回復を促進します。',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20patient%20wearing%20comfortable%20medical%20gown%20receiving%20professional%20electrotherapy%20treatment%20in%20bright%20modern%20orthopedic%20clinic%2C%20fully%20clothed%20patient%20lying%20on%20treatment%20table%20with%20therapeutic%20electrodes%20attached%2C%20Japanese%20therapist%20operating%20advanced%20electrical%20stimulation%20equipment%2C%20well-lit%20medical%20facility%20with%20natural%20sunlight%2C%20professional%20healthcare%20environment%20with%20patient%20wearing%20appropriate%20medical%20attire%2C%20clean%20white%20treatment%20room%20with%20modern%20medical%20technology&width=400&height=300&seq=electrotherapy-clothed-patient-2024&orientation=landscape'
    },
    {
      icon: 'ri-run-line',
      title: '運動療法',
      description: '個人の症状に合わせた運動プログラムで、機能回復と再発防止をサポートします。',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20patient%20performing%20therapeutic%20exercise%20program%20with%20Japanese%20therapist%20in%20rehabilitation%20center%2C%20Asian%20patient%20doing%20guided%20physical%20therapy%20exercises%20with%20professional%20Japanese%20therapist%2C%20modern%20exercise%20equipment%2C%20bright%20rehabilitation%20gym%20in%20Japan%2C%20functional%20movement%20training%20with%20Japanese%20healthcare%20professional%2C%20recovery-focused%20environment%20in%20Japanese%20medical%20facility&width=400&height=300&seq=service-exercise-jp&orientation=landscape'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            診療メニュー
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            患者様一人ひとりの症状に合わせた最適な治療法をご提案いたします
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <img
                src={service.image}
                alt={service.title}
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-lg mb-4">
                  <i className={`${service.icon} text-2xl text-[#3cb371]`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600 mb-4">
                  {service.description}
                </p>
                <button className="bg-[#3cb371] hover:bg-[#2e8b57] text-white px-4 py-2 rounded-full font-medium transition-colors whitespace-nowrap cursor-pointer">
                  詳細を見る
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
